module.exports = __webpack_public_path__ + "static/media/settings-blue.498314fa.svg";